module.exports = __webpack_public_path__ + "static/media/shapes_20.26be8b1c.svg";